import { RegionType } from '@wix/shoutout-email-model-v3';
import { get, isNaN } from 'lodash';
import * as cssUtils from '../../utils/css-utils';
import { defaultTextPadding } from '../../utils/defaults';
import { getMessageWidth } from '../../utils/get-message-width';
import { getPxValue } from '../../utils/line-height-to-px';
import { getButton } from './get-button';
import { getText } from './get-text';
export const getItemGridSection = ({ composerData, region, css, experiments, isRtl, }) => {
    if (region.type !== RegionType.ItemGrid) {
        throw Error('ItemGrid must be passed');
    }
    const rules = [
        get(region, 'data.styles.region', {}),
        css['so-global-region-mix'],
        css['so-global-region'],
    ];
    const padding = cssUtils.padding(rules);
    const margin = cssUtils.margin(rules);
    const mobileCssClass = cssUtils.getRegionMobileCssClass(rules, true);
    const button = getButton({ css, experiments, isRtl, region });
    const title = getText({
        css,
        isRtl,
        region,
        cssClass: 'so-global-h3',
        componentStylePath: 'data.styles.title',
        bolden: true,
    });
    const description = getText({
        css,
        isRtl,
        region,
        cssClass: 'so-global-p1',
        componentStylePath: 'data.styles.description',
    });
    const price = getText({
        css,
        isRtl,
        region,
        cssClass: 'so-global-h3',
        componentStylePath: 'data.styles.price',
        bolden: true,
    });
    const verticalSpacing = region?.data?.styles?.spacings?.verticalSpacing
        ? parseInt(region?.data?.styles?.spacings?.verticalSpacing, 10)
        : null;
    const leftColumnPadding = (verticalSpacing !== null ? verticalSpacing / 2 : null) ??
        css['so-global-region-mix-left']?.paddingRight ??
        defaultTextPadding;
    const rightColumnPadding = (verticalSpacing !== null ? verticalSpacing / 2 : null) ??
        css['so-global-region-mix-right']?.paddingLeft ??
        defaultTextPadding;
    let parsedLeftColumnPadding = parseInt(leftColumnPadding.toString(), 10);
    if (isNaN(parsedLeftColumnPadding)) {
        parsedLeftColumnPadding = 25;
    }
    let parsedRightColumnPadding = parseInt(rightColumnPadding.toString(), 10);
    if (isNaN(parsedRightColumnPadding)) {
        parsedRightColumnPadding = parsedLeftColumnPadding;
    }
    if (parsedRightColumnPadding + parsedRightColumnPadding > 50) {
        parsedLeftColumnPadding = 25;
        parsedRightColumnPadding = 25;
    }
    const spacerHeight = parseInt(region?.data?.styles?.spacings?.horizontalSpacing ?? '12px', 10);
    const fonts = [];
    if (title.fontFamily) {
        fonts.push(title.fontFamily.split(',')[0]);
    }
    if (description.fontFamily) {
        fonts.push(description.fontFamily.split(',')[0]);
    }
    if (price.fontFamily) {
        fonts.push(price.fontFamily.split(',')[0]);
    }
    if (button.fontFamily) {
        fonts.push(button.fontFamily.split(',')[0]);
    }
    const messageContentWidth = getMessageWidth(composerData, css);
    const { leftColumnWidth, rightColumnWidth, spaceForColumn } = calcWidths(messageContentWidth, parsedLeftColumnPadding, parsedRightColumnPadding, margin, padding);
    return {
        items: region.data.items,
        show: region.data?.show,
        buttonLabel: region.data?.buttonLabel,
        layout: region.data?.layout,
        cssClass: mobileCssClass,
        innerPadding: padding,
        outerPadding: margin,
        leftColumnPadding: getPxValue(parsedLeftColumnPadding),
        rightColumnPadding: getPxValue(parsedRightColumnPadding),
        leftColumnWidth,
        rightColumnWidth,
        spacerHeight,
        button,
        title,
        description,
        price,
        fonts,
        spaceForColumn,
    };
};
export function calcWidths(messageContentWidth, leftColumnPadding, rightColumnPadding, margin, padding) {
    const availableSpace = messageContentWidth - ((margin?.left || 0) + (margin?.right || 0));
    const paddingSpace = leftColumnPadding + rightColumnPadding;
    const contentSpace = availableSpace -
        ((padding.right || 0) + (padding.left || 0)) -
        paddingSpace;
    const spaceForColumn = contentSpace / 2;
    const leftColumnWidth = `${((spaceForColumn + rightColumnPadding + (padding.left || 0)) * 100) /
        availableSpace}%`;
    const rightColumnWidth = `${((spaceForColumn + leftColumnPadding + (padding.right || 0)) * 100) /
        availableSpace}%`;
    return {
        leftColumnWidth,
        rightColumnWidth,
        spaceForColumn: Math.floor(spaceForColumn),
    };
}
//# sourceMappingURL=get-item-grid-section.js.map